import styled from 'styled-components';
import { fontSize, lineHeight, colourPalette } from 'styles/styles';

export const FiltersTableFilterItemStyle = {
  Container: styled.div`
    height: 38px;
    padding: 0 8px;
    background-color: ${colourPalette.neutral0};
    border-radius: 4px;
    display: flex;
    align-items: center;
    color: ${colourPalette.neutral600};
    cursor: pointer;
    & > p {
      margin: 0;
      font-size: ${fontSize.fontSizeSM};
      line-height: ${lineHeight.lineHeightMD};
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    &.is-selected {
      background-color: #eaf0fd;
      color: ${colourPalette.blue600} !important;
    }
    &:hover {
      background-color: ${colourPalette.neutral200};
      color: ${colourPalette.neutral600};
    }
  `,
};
